import { Component, input, InputSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-regular-main',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './regular-main.component.html',
  styleUrls: ['./regular-main.component.scss'],
})
export class RegularMainComponen {
  public id: InputSignal<number> = input<number>();
  public title: InputSignal<string> = input<string>(); // TODO: CAMBIAR A OBJETO DE TRADUCCIONES
  public indexCard: InputSignal<number> = input<number>();
  public durationMinutes: InputSignal<number> = input<number>();
  public isDuration15Minutes: InputSignal<boolean> = input<boolean>();
}
